import { forwardRef, memo, PropsWithChildren } from "react";
import "./panel.scss";

interface PanelProps extends PropsWithChildren {
  className?: string;
  role?: string;
  id?: string;
  tabIndex?: number;
  onClick?: () => void;
  noBorder?: boolean;
  hidden?: boolean;
  style?: React.CSSProperties;
}

type Ref = HTMLDivElement;

const PanelComponent = forwardRef<Ref, PanelProps>(
  ({ role, className = "", children, noBorder, hidden, ...restProps }, ref) => {
    return (
      <div
        className={`panel-container ${className} ${role === "button" ? "hover" : ""} ${
          noBorder ? "no-border" : ""
        } ${hidden ? "hidden" : ""}`}
        ref={ref}
        {...restProps}
      >
        {children}
      </div>
    );
  },
);

PanelComponent.displayName = "PanelComponent";

export const Panel = memo(PanelComponent);
export { PanelBody } from "./panel-body";
export { PanelFooter } from "./panel-footer";
export {
  PanelHeader,
  PanelActionArea,
  PanelDescription,
  PanelTitle,
  PanelTitleArea,
  PanelSubTitle,
} from "./panel-header";
